export default __webpack_public_path__ + "images/2a651d019d423aa8263e75c4f019cbea-learning_empathy.svg";